export const THRIVA_API_REQUEST_ERROR_NAME = 'ThrivaApiRequestError';
const DEFAULT_MESSAGE = 'UNKNOWN_ERROR';
export class ThrivaApiRequestError extends Error {
    // The name of the class
    name;
    // Formatted error message. See the [`Error`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error) class for more details.
    message;
    // The errror message return from the request.
    originalMessage;
    // The error code returned from the request.
    code;
    // The original JSON response that caused the error.
    response;
    // The URL of the original request that caused the error
    url;
    // The options of the original request that caused the error
    options;
    // The API error type
    apiErrorType = 'invalid_request';
    // A custom message from the API
    apiMessage = '';
    constructor(message = DEFAULT_MESSAGE, url, options, code, response) {
        // 'Error' breaks prototype chain here
        super(message);
        // restore prototype chain, see https://stackoverflow.com/questions/41102060/typescript-extending-error-class
        // Also see https://github.com/Microsoft/TypeScript-wiki/blob/main/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        // and https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error#custom_error_types
        const actualProto = new.target.prototype;
        Object.setPrototypeOf(this, actualProto);
        message = message || DEFAULT_MESSAGE;
        code = code || 0;
        this.name = THRIVA_API_REQUEST_ERROR_NAME;
        this.message = code === 0 ? message : `${code}: ${message}`;
        this.originalMessage = message;
        this.code = code;
        this.response = response;
        this.url = url;
        this.options = options;
        if (response?.error && response?.error.type) {
            if (response.error.type) {
                this.apiErrorType = response.error.type;
            }
            if (response.error.message) {
                this.apiMessage = response.error.message;
            }
        }
    }
}
//# sourceMappingURL=ThrivaApiRequestError.js.map